import * as _ from "lodash";
import * as angular from "angular";
import { Issue } from "../../../models/issue.model";
import { DialogUtils } from "../../../helper/dialog.helper";
import { IssueDataProvider } from "../../../data-provider/issue.dp";

let IssueStatusComponent = {
    selector: "vcIssueStatus",
    templateUrl: "/angular/components/issue/modals/issue-status.component.html",
    bindings: {
        selectedIssue: "=",
    },
    controller: class IssueStatusController {
        // * bindings for typescript compiler *
        public selectedIssue: Issue;
        // ************************************

        private dataProvider: IssueDataProvider;
        private dialog: DialogUtils;

        public issue: Issue;
        public statuses: object;

        constructor(
            IssueDataProvider: IssueDataProvider,
            DialogUtils: DialogUtils
        ) {
            this.dataProvider = IssueDataProvider;
            this.dialog = DialogUtils;

            this.dataProvider.getStatuses().then((statuses) => {
                this.statuses = statuses;
            });
        }

        $onInit() {
            this.issue = _.cloneDeep(this.selectedIssue);
        }

        confirm(): void {
            this.dialog.hide(this.issue);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("issue")
    .component(IssueStatusComponent.selector, IssueStatusComponent);
